import { render, staticRenderFns } from "./SpamDomainForm.vue?vue&type=template&id=a708ae7a&scoped=true"
import script from "./SpamDomainForm.vue?vue&type=script&lang=js"
export * from "./SpamDomainForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a708ae7a",
  null
  
)

export default component.exports